import { render, staticRenderFns } from "./deregister-cooldown-page.vue?vue&type=template&id=3d2e5880&scoped=true"
import script from "./deregister-cooldown-page.vue?vue&type=script&lang=js"
export * from "./deregister-cooldown-page.vue?vue&type=script&lang=js"
import style0 from "./deregister-cooldown-page.vue?vue&type=style&index=0&id=3d2e5880&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2e5880",
  null
  
)

export default component.exports